export const determineUpdatesToGameInformation = (gameData, cashChg, currentlyActive) => {
     
        gameData.currentCash = (+gameData.currentCash + +cashChg).toFixed(2);
        gameData.currentCash = gameData.currentCash.toString();
        const featureIndx = 
            gameData.unlockedFeatures.findIndex(elem => elem.featureName === "moneyBuilder");
        if (featureIndx !== -1){
            if (currentlyActive === true){
                gameData.unlockedFeatures[featureIndx].setup = "active";
            }else{
                gameData.unlockedFeatures[featureIndx].setup = "inactive";
            }
        }
        const iconIndx = 
            gameData.iconTable.findIndex(elem => elem.iconName === "moneyBuilderNewLevel");
        if (iconIndx !== -1){
            gameData.iconTable.splice(iconIndx, 1);
        }
        let gameBodyObj = {
            "currentCash": gameData.currentCash,
            "unlockedFeatures": gameData.unlockedFeatures,
            "iconTable": gameData.iconTable
        };
      
        const conditionIndx = 
            gameData.conditionsTable.findIndex(elem => elem.condName === "has-investments");
        let updateConditionTable = false;
        if (conditionIndx === -1){
            if (currentlyActive === true){
                const investmentCondObj = {condName: "has-investments", conditionClass: "game"};
                gameData.conditionsTable.push(investmentCondObj);
                updateConditionTable = true;
            }
        }else{
            if (currentlyActive === false){
                gameData.conditionsTable.splice(conditionIndx, 1);
                updateConditionTable = true;
            }
        }
    const returnObj = {gameBodyObj: gameBodyObj, updateConditionTable: updateConditionTable};
    return returnObj
        
}
export default determineUpdatesToGameInformation;